document.addEventListener('alpine:init', () => {
  Alpine.data('Cart', () => ({
    cart: {},
    init() {
      this.InitSelf();
    },
    InitSelf() {
      let am = this;
      am.cart = JSON.parse(am.$el.dataset.cart);
      am.CheckPreorders();
    },
    CheckPreorders() {
      let am = this;
      let preorder_props = [...new Set(am.cart.items.map((item) => item.properties['_preorder']))];
      let $modal = document.querySelector('#cart-modal-preorder');
      // console.log(preorder_props)
      if (preorder_props.length > 1) {
        if (preorder_props.includes('false')) {
          $modal.querySelector('.cm-modal-content').innerHTML = $modal.dataset.messageInstock;
          $modal.dispatchEvent(new CustomEvent('modal-open'));  
        }
        else {
          $modal.querySelector('.cm-modal-content').innerHTML = $modal.dataset.messagePreorder;
          $modal.dispatchEvent(new CustomEvent('modal-open'));  
        }
      }
    }
  }));
});


class CustomModal extends HTMLElement {
  constructor() {
    super();
    this.SetupEventListeners();
  }
  SetupEventListeners() {
    let _this = this;
    _this.querySelectorAll('.cm-modal-close').forEach(($close) => {
      $close.addEventListener('click', (e) => {
        e.preventDefault();
        _this.dispatchEvent(new CustomEvent('modal-close'));
      });
    });

    _this.addEventListener('modal-open', () => {
      _this.focus();
      _this.setAttribute('aria-hidden', false);        
    });

    _this.addEventListener('modal-close', () => {
      _this.setAttribute('aria-hidden', true);
    });
  }
};
customElements.define('custom-modal', CustomModal);